import React from 'react'
import {Route, IndexRedirect} from 'react-router'

import NotificationView from 'views/NotificationView'

export default trackRoute => {
  return (
    <Route
      path='notifications'
      title='Notifications'
      component={NotificationView}
      onEnter={trackRoute('traffic')}
    />
  )
}



// WEBPACK FOOTER //
// ./client/routes/notifications.js